import api from "@/router/api";

export default {
  async getAllTutorialTopico() {
    const response = await api.get("/tutoriais-topico");
    return response.data;
  },

  async getTutorialTopicoById(id) {
    const response = await api.get(`/tutoriais-topico/${id}`);
    return response.data;
  },

  async getTutorialTopicoTopicoPaginado(page, size) {
    const response = await api.get(`/tutoriais-topico/paginado`, {
      params: {
        page,
        size,
      },
    });
    return response.data;
  },

  async getTutorialTopicoByTopicoId(topicoId) {
    const response = await api.get(`/tutoriais-topico/topico/${topicoId}`);
    return response.data;
  },

  async getTutorialTopicoByTopicoIdPaginado(topicoId, page, size) {
    const response = await api.get(
      `/tutoriais-topico/topico/${topicoId}/paginado`,
      {
        params: {
          page,
          size,
        },
      }
    );
    return response.data;
  },

  async createTutorialTopico(tutorialTopico) {
    const response = await api.post("/tutoriais-topico", tutorialTopico);
    return response.data;
  },

  async updateTutorialTopico(id, tutorialTopico) {
    const response = await api.put(`/tutoriais-topico/${id}`, tutorialTopico);
    return response.data;
  },

  async deleteTutorialTopico(id) {
    const response = await api.delete(`/tutoriais-topico/${id}`);
    return response.data;
  },
};
